import * as React from "react";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { ReactComponent as CalendarIcon } from "../../assets/images/calender-icon.svg";
import { Controller, useFormContext } from "react-hook-form";

const CFormDatePicker = ({
  name,
  label,
  value,
  onChange,
  error,
  helperText,
  disabled,
  className,
  readOnly = true,
  ...props
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange: formOnChange, value: formValue }, fieldState: { error: formError } }) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={label}
            value={formValue || null}
            onChange={formOnChange}
            disabled={disabled}
            renderInput={(params) => (
              <TextField
                {...params}
                error={!!formError}
                helperText={formError ? formError.message : helperText}
                inputProps={{ 
                  ...params.inputProps,
                  readOnly: readOnly,
                  placeholder: "DD/MM/YYYY"
                }}
              />
            )}
            components={{ OpenPickerIcon: CalendarIcon }}
            className={`CDatpicker ${className}`}
            inputFormat="DD/MM/YYYY"
            {...props}
          />
        </LocalizationProvider>
      )}
    />
  );
};

CFormDatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  helperText: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  readOnly: PropTypes.bool,
};

export default CFormDatePicker;